export const COOKIES = {
  AUTH_ACCESS_TOKEN: 'cuboh_access',
  AUTH_REFRESH_TOKEN: 'cuboh_refresh',
  REPORTING_ACCESS_TOKEN: 'reporting_access',
};

export const PERMISSIONS = {
  FETCH_INTEGRATIONS: 'Fetch Integrations',
  FETCH_MENU_ITEM: 'Fetch Menu Item',
  FETCH_ORDER: 'Fetch Order',
  CREATE_CREDENTIALS: 'Integration Credentials',
  TOGGLE_MENU_ITEM: 'Toggle Menu Item',
  UPDATE_COMPANY_SETTINGS: 'Update Company Settings',
  UPDATE_INTEGRATIONS: 'Update Integrations',
  UPDATE_ORDER: 'Update Order',
  VIEW_MERCHANTS: 'View Merchants',
};

export const SOURCE = 'source';

/** Action Types */
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const SET_ORDER_DISPLAY_TOKEN = 'SET_ORDER_DISPLAY_TOKEN';
export const SET_DATA = 'SET_DATA';
export const UPDATE_COMPANY = 'UPDATE_COMPANY';
export const UPDATE_MERCHANT = 'UPDATE_MERCHANT';
export const UPDATE_PARENT_COMPANY = 'UPDATE_PARENT_COMPANY';
export const SET_PROXY_USER = 'SET_PROXY_USER';
export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';
export const SET_USER_META = 'SET_USER_META';
export const SET_CORPA_IMPERSONATION = 'SET_CORPA_IMPERSONATION';

export const RESET_SUCCESS_MSG =
  "We've sent a link to reset your password. You'll see our email in your inbox. Please check your spam folder too.";

export const RESET_FAILED_MSG = 'Please try again or contact support if this persists';
export const FULFILLED = 'fulfilled';
export const REJECTED = 'rejected';
